// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/playing.svg';

export const Playing = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
